import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';

import { Box, Checkbox, FormControlLabel, FormGroup, Grid, Modal, Typography } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import BoosterPng from '../../assets/Booster.png';
import { LetsGoBtn } from '../../components/Buttons';
import { StyledLabel } from '../../components/StyledComponents';

import ApiService from '../../helpers/apiHelper';
import { setIsOpenBoostersModal, setIsOpenServicePromoteModal } from '../../redux/mainReducer';
import { base } from '../../redux/thunk';
import './CancelModal.css';
import { useSnackbar } from 'notistack';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 710, md: 800, lg: 800, xl: 800 },

  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px 20px 30px 20px', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: '100vh',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

function ServicePromoteModal({
  isOpenModal,
  id = '',
  title = '',
  setter,
  boosters,
  getUserDataThunk
}) {
  const dispatch = useDispatch();

  const api = new ApiService('posts/promoted-services/create');
  // const api = new ApiService('promoted-services/create');
  const { enqueueSnackbar } = useSnackbar();

  const [valuePrice, setValuePrice] = useState(2);
  const [dayCount, setDayCount] = useState(1);

  const [interesting, setInteresting] = useState(false);
  const [interestingRib, setInterestingRib] = useState(true);
  const [search, setSearch] = useState(false);

  const [boostersError, setBoostersError] = useState(true);

  const calc = () => {
    return dayCount * valuePrice;
  };
  const getPlace = () => {
    if (interesting && !interestingRib && !search) {
      return ['RIBBON_INTERESTED'];
    } else if (interestingRib && !interesting && !search) {
      return ['INTERESTED_SERVICES'];
    } else if (search && !interesting && !interestingRib) {
      return ['PRODUCT_SEARCH_PLACE'];
    } else if (interestingRib && interesting && !search) {
      return ['INTERESTED_SERVICES', 'RIBBON_INTERESTED'];
    } else if (interesting && search && !interestingRib) {
      return ['RIBBON_INTERESTED', 'PRODUCT_SEARCH_PLACE'];
    } else if (interestingRib && search && !interesting) {
      return ['INTERESTED_SERVICES', 'PRODUCT_SEARCH_PLACE'];
    } else if (interestingRib && interesting && search) {
      return ['INTERESTED_SERVICES', 'RIBBON_INTERESTED', 'PRODUCT_SEARCH_PLACE'];
    }
  };

  const submit = () => {
    api
      .sendRequest({ promotedDays: dayCount, placePromoteServiceType: getPlace(), serviceId: id })
      .then((res) => {
        enqueueSnackbar(`Просування товару активовано`, { variant: 'success' });
        dispatch(setIsOpenServicePromoteModal({ isOpen: false, id: '', title: '', setter: null }));
        getUserDataThunk();
        setter();
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка', { variant: 'error' });
      });
  };
  useEffect(() => {
    if (boosters < dayCount * valuePrice) {
      setBoostersError(true);
    } else {
      setBoostersError(false);
    }
  }, [boosters, dayCount, valuePrice]);

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }

          dispatch(
            setIsOpenServicePromoteModal({ isOpen: false, id: '', title: '', setter: null })
          );
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_cancel_modal"
      >
        <Box sx={style} className="bonfair_cancel_modal-box">
          <CloseIcon
            className="bonfair_cancel_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(
                setIsOpenServicePromoteModal({ isOpen: false, id: '', title: '', setter: null })
              );
            }}
          />

          <Grid container spacing={0}>
            <Grid item xs={12} md={12} lg={12}>
              <StyledLabel className="cancelModal-title-text">
                {/* {translate('bonfair_service_modal')} */}
                {'Просувати товар'}
              </StyledLabel>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Typography
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  window?.open(`/ua/service/${id}`);
                  window.scrollTo({ top: 0 });
                }}
                sx={{
                  zIndex: 99,
                  cursor: 'pointer',
                  position: 'relative',
                  fontFamily: 'FixelText-Medium',
                  fontSize: '20px',
                  ':hover': {
                    color: '#60A5DF'
                  }
                }}
              >
                {title}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{ pb: '16px', borderBottom: '3px solid #F5F4F4', mb: { xs: '16px', sm: '24px' } }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    gap: '10px',
                    alignItems: 'center',
                    // border: '1px solid #C8C8C8',

                    borderRadius: '5px',
                    width: '100%',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    textAlign: 'left',
                    color: '#7C7C7C'
                  }}
                >
                  {`Баланс бустерів: `}
                  <Typography
                    variant="p"
                    sx={{
                      margin: '0px 0px',
                      wordBreak: 'break-word',
                      fontFamily: 'FixelText-Medium !important',
                      fontWeight: 500,
                      fontSize: '16px',
                      textAlign: 'left',
                      alignItems: 'center',
                      display: 'flex',
                      color: boostersError ? 'red' : 'black'
                    }}
                  >
                    {boosters}
                    <img
                      width={22}
                      height={18}
                      src={BoosterPng}
                      alt="booster"
                      style={{ marginRight: '10px', marginLeft: '10px', marginBottom: '5px' }}
                    />
                  </Typography>
                  <LetsGoBtn
                    colorScheme="white"
                    width="140px"
                    margin="0px 0px 0px auto"
                    text="Поповнити"
                    onClick={() => {
                      dispatch(setIsOpenBoostersModal(true));
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/*<Stack sx={{ width: '100%' }}>*/}
              <Typography
                variant="p"
                sx={{
                  margin: '0px 0px 10px',
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '16px', sm: '18px', md: '20px' },
                  textAlign: 'left',
                  color: '#7C7C7C'
                }}
              >
                Оберіть місце просування:
              </Typography>

              <FormGroup
                onChange={(event, value) => {
                  if (event?.target?.name === 'interesting') {
                    setInteresting(!interesting);
                    if (event.target?.checked) {
                      setValuePrice(valuePrice + 2);
                    } else {
                      setValuePrice(valuePrice - 2);
                    }
                  } else if (event?.target?.name === 'interestingRib') {
                    setInterestingRib(!interestingRib);
                    if (event.target?.checked) {
                      setValuePrice(valuePrice + 2);
                    } else {
                      setValuePrice(valuePrice - 2);
                    }
                  } else if (event?.target?.name === 'search') {
                    setSearch(!search);
                    if (event.target?.checked) {
                      setValuePrice(valuePrice + 2);
                    } else {
                      setValuePrice(valuePrice - 2);
                    }
                  }
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      size="large"
                      disableRipple
                      checked={interesting}
                      sx={{ p: '0px 5px 0px 10px !important' }}
                    />
                  }
                  name="interesting"
                  label={
                    <Typography
                      sx={{
                        fontSize: { xs: '16px', sm: '18px', md: '20px' },
                        fontFamily: 'FixelText-Regular !important'
                      }}
                    >
                      {'Цікавеньке (стрічка)'}
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="large"
                      disableRipple
                      checked={interestingRib}
                      sx={{ p: '0px 5px 0px 10px !important' }}
                    />
                  }
                  name="interestingRib"
                  label={
                    <Typography
                      sx={{
                        fontSize: { xs: '16px', sm: '18px', md: '20px' },
                        fontFamily: 'FixelText-Regular !important'
                      }}
                    >
                      {'Блок “Можуть вам сподобатись”'}
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="large"
                      disableRipple
                      checked={search}
                      sx={{ p: '0px 5px 0px 10px !important' }}
                    />
                  }
                  name="search"
                  label={
                    <Typography
                      sx={{
                        fontSize: { xs: '16px', sm: '18px', md: '20px' },
                        fontFamily: 'FixelText-Regular !important'
                      }}
                    >
                      {'Сторінка пошуку товарів'}
                    </Typography>
                  }
                />
              </FormGroup>
              {/*</Stack>*/}
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                pb: '32px',
                borderBottom: '3px solid #F5F4F4',
                mb: { xs: '16px', sm: '24px' }
              }}
            >
              {/*<Stack sx={{ width: '100%', ml: 1 }}>*/}
              {/*<Typography*/}
              {/*  variant="p"*/}
              {/*  sx={{*/}
              {/*    margin: '0px 0px 10px',*/}
              {/*    wordBreak: 'break-word',*/}
              {/*    fontFamily: 'FixelText-Regular !important',*/}
              {/*    fontSize: { xs: '16px', sm: '18px', md: '20px' },*/}
              {/*    color: '#7c7c7c',*/}
              {/*    textAlign: 'left'*/}
              {/*  }}*/}
              {/*>*/}
              {/*  Оберіть тривалість просування:*/}
              {/*</Typography>*/}
              <Box sx={{ display: 'flex', height: 20, mb: '24px' }}>
                <Typography
                  variant="p"
                  sx={{
                    margin: '10px 0px 10px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    color: '#7c7c7c',
                    textAlign: 'left'
                  }}
                >
                  Ціна просування:
                </Typography>
                <Typography
                  variant="p"
                  sx={{
                    margin: '10px 0px 10px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    color: '#7c7c7c',
                    textAlign: 'left',
                    ml: 'auto'
                  }}
                >
                  {valuePrice}
                  <img
                    width={20}
                    height={16}
                    src={BoosterPng}
                    alt="booster"
                    style={{ marginLeft: '5px', marginRight: '5px' }}
                  />{' '}
                  /день
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', height: 20 }}>
                <Typography
                  variant="p"
                  sx={{
                    margin: '10px 20px 0px 0px',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    color: '#7c7c7c',
                    textAlign: 'left'
                  }}
                >
                  Кількість днів:
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingTop: '0px',
                    ml: 'auto',
                    mt: '10px'
                  }}
                >
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      p: 1,
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: dayCount === 1 ? '#F5F4F4' : '#E2F2FF',
                      borderRadius: '50px',
                      fontSize: '20px'
                    }}
                    onClick={() => dayCount > 1 && setDayCount(dayCount - 1)}
                  >
                    -
                  </Typography>
                  {/*<TextField*/}
                  {/*  variant={'standard'}*/}
                  {/*  sx={{ maxWidth: '30px', margin: '0px 10px' }}*/}
                  {/*  inputProps={{ style: { textAlign: 'center' } }}*/}
                  {/*  value={dayCount}*/}
                  {/*  onChange={(event) => {*/}
                  {/*    if (*/}
                  {/*      Number.isInteger(+event.target.value) &&*/}
                  {/*      +event.target.value <= 999 &&*/}
                  {/*      +event.target.value !== 0*/}
                  {/*    ) {*/}
                  {/*      setDayCount(+event.target.value);*/}
                  {/*    }*/}
                  {/*  }}*/}
                  {/*/>*/}
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium !important',
                      fontWeight: '500',
                      fontSize: { xs: '16px', sm: '18px', md: '20px' },
                      color: '#1B1B1B',
                      m: '0px 5px'
                    }}
                  >
                    {dayCount}
                  </Typography>
                  <Typography
                    sx={{
                      cursor: 'pointer',
                      p: 1,
                      display: 'flex',
                      width: '40px',
                      height: '40px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: '#E2F2FF',
                      borderRadius: '50px',
                      fontSize: '20px'
                    }}
                    onClick={() => dayCount < 999 && setDayCount(dayCount + 1)}
                  >
                    +
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              sx={{
                margin: '0px 0px 10px'
              }}
            >
              <Typography
                variant="p"
                sx={{
                  wordBreak: 'break-word',
                  fontFamily: 'FixelText-Regular !important',
                  fontSize: { xs: '14px', sm: '16px' },
                  textAlign: 'left',
                  color: '#7C7C7C'
                }}
              >
                Зверніть увагу! Якщо тривалість просування перевищує залишок днів підписки, а
                підписку не буде продовжено, просування припиниться після її завершення. Бустери не
                підлягають поверненню.
              </Typography>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                {' '}
                <Typography
                  sx={{
                    margin: '0px ',
                    wordBreak: 'break-word',
                    fontFamily: 'FixelText-Regular !important',
                    fontSize: { xs: '16px', sm: '18px', md: '20px' },
                    textAlign: 'left',
                    color: '#7c7c7c',
                    width: '100%'
                  }}
                >
                  До сплати:
                </Typography>
                <Typography
                  sx={{
                    color: boostersError ? 'red' : 'black',
                    marginLeft: 'auto',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {calc()}
                  <img
                    width={20}
                    height={16}
                    src={BoosterPng}
                    alt="booster"
                    style={{ marginLeft: '10px' }}
                  />
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                margin: '20px auto 0px',
                maxWidth: '540px',
                position: 'relative'
              }}
            >
              <LetsGoBtn
                colorScheme="blue"
                lineHeight="26px"
                disabled={
                  boosters < dayCount * valuePrice || (!interesting && !interestingRib && !search)
                }
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  submit();
                }}
                width={180}
                margin={'0 auto'}
                style={{ textTransform: 'inherit' }}
                text="Просувати"
              />
              <Typography
                sx={{
                  color: boostersError ? 'red' : 'black',
                  position: 'absolute',
                  bottom: '-20px',
                  display: boostersError ? 'flex' : 'none',
                  alignItems: 'center',
                  fontSize: '14px'
                }}
              >
                {boosters < dayCount * valuePrice ? 'Недостатьно бустерів' : ''}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    boosters: state.global.boosters
  };
};
export default connect(mapStateToProps, { getUserDataThunk: base?.getUserDataThunk })(
  ServicePromoteModal
);
